export default __webpack_public_path__ + "static/media/DNo.37-2.23eecec6.jpg";